var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTenant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.27,27.82l-26-21.08a2,2,0,0,0-2.52,0l-26,21.08A2,2,0,0,0,4,29.37v2.35a2,2,0,0,0,2,2H9.4l0,22a2,2,0,0,0,2,2H52.61a2,2,0,0,0,2-2l0-22H58a2,2,0,0,0,2-2V29.37A2,2,0,0,0,59.27,27.82ZM44,40.09a2.08,2.08,0,0,1-2.08,1.67H35a1,1,0,0,0-1,1v6.89a2.08,2.08,0,0,1-1.67,2.08,2,2,0,0,1-2.33-2v-7a1,1,0,0,0-1-1h-6.9A2.08,2.08,0,0,1,20,40.09a2,2,0,0,1,2-2.33h7a1,1,0,0,0,1-1v-6.9a2.08,2.08,0,0,1,1.66-2.08,2,2,0,0,1,2.34,2v7a1,1,0,0,0,1,1h7A2,2,0,0,1,44,40.09Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenant);
export default __webpack_public_path__ + "static/media/tenant.b0456ae8.svg";
export { ForwardRef as ReactComponent };